import { BottomSheetTextInput } from '@gorhom/bottom-sheet'
import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import { IS_WEB } from 'constants/platform'
import { useTheme } from 'contexts'
import React, { useState } from 'react'
import { StyleSheet } from 'react-native'

import { BottomSheetNavbar } from 'partials/BottomSheetNavbar'
import { Page } from 'partials/Page'

import { Box } from 'widgets/Box'
import { TextInput } from 'widgets/TextInput'

import { useTextEditorModal } from 'contexts/TextEditorModalContext'

interface TextEditorPageProps {
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}

export const TextEditorPage = ({ drawerNavigationRef, ...rest }: TextEditorPageProps) => {
  const theme = useTheme()
  const textEditorModalRef = useTextEditorModal()
  const { title, inputText, onSubmit } = rest?.data

  const [input, setInput] = useState<string>(inputText ?? '')

  const styles = StyleSheet.create({
    textInput: {
      flex: 1,
      color: theme.colors.v2black,
      backgroundColor: theme.colors.white,
    },
    bottomSheetTextInput: {
      flex: 1,
      color: theme.colors.v2black,
      backgroundColor: theme.colors.white,
      fontSize: theme.fonts.sizes.sm + 2,
      paddingHorizontal: theme.spacing.sm,
    },
  })

  return (
    <Page enableKeyboardAvoidingView isOnBottomSheet renderHelmet={false}>
      <BottomSheetNavbar
        title={title ?? ''}
        shareTitle='Done'
        shareColor='greyDarker'
        onBack={() => textEditorModalRef?.current?.dismiss()}
        onShare={() => {
          onSubmit && onSubmit(input)
          textEditorModalRef?.current?.dismiss()
        }}
      />

      <Box flex={1}>
        {!IS_WEB ? (
          <BottomSheetTextInput
            multiline
            value={input}
            placeholder='Add description...'
            style={styles.bottomSheetTextInput}
            onChange={(e) => setInput(e?.nativeEvent?.text ?? '')}
          />
        ) : (
          <TextInput
            multiline
            placeholder='Add description...'
            placeholderTextColor={theme.colors.greyDark}
            selectionColor='v2primary'
            style={styles.textInput}
            onChange={() => setInput}
            value={input}
          />
        )}
      </Box>
    </Page>
  )
}
